/**
 * noindexPaths.js
 *
 * React wrapper over the generated `noindexPaths.json` — the thin programmatic
 * long tail (pages with 0 clicks AND < 50 impressions over the trailing 90
 * days in Google Search Console, excluding protected editorial / money /
 * profile prefixes).
 *
 * After the September 2026 Google spam update demoted the whole domain, these
 * paths are (a) dropped from every sitemap and (b) served `noindex, follow`,
 * so crawl + quality signal concentrates on pages with real demand. `follow`
 * keeps the internal link graph intact.
 *
 * Regenerate the JSON from fresh GSC data as the site recovers; removing a
 * path re-exposes it.
 */
import paths from './noindexPaths.json';

export const NOINDEX_PATHS = new Set(paths);

export function isNoindexPath(pathname) {
  if (!pathname) return false;
  const p = pathname.replace(/\/+$/, '') || '/';
  return NOINDEX_PATHS.has(p);
}
